import { AuthenticationManager } from '@frontend/authentication-v2';
import { useState } from 'react';

interface ViewProps {
    authenticated: boolean;
    onLoginSucceeded: () => void;
}

const useAuthentication = (): ViewProps => {
    const [authenticated, setAuthenticated] = useState<boolean>(AuthenticationManager.getInstance().hasValidToken());

    const onLoginSucceeded = (): void => {
        setAuthenticated(AuthenticationManager.getInstance().hasValidToken());
    };

    return {
        authenticated,
        onLoginSucceeded
    };
};

export default useAuthentication;
